import clsx from 'clsx';
import RegioStageBox from '../RegioStageBox/RegioStageBox';
import styles from './RegioStage.module.scss';
import RegioStageBackgroundIcon from './RegioStageBackgroundIcon/RegioStageBackgroundIcon';
import type { RegioStageProps } from './types';

const RegioStage = ({
  city,
  description,
  headline,
  configuratorUrl,
  stageBoxTitle,
}: RegioStageProps) => {
  const stageHeadline = headline || `Hey ${city}!`;
  const isLongHeadline = stageHeadline.length > 25;
  const configuratorBaseUrl = new URL(configuratorUrl).origin;

  return (
    <div className={styles.base}>
      <div className={styles.iconWrapper}>
        <RegioStageBackgroundIcon variant="umbrella" size="large" />
        <RegioStageBackgroundIcon variant="plant-leaf" size="small" />
        <RegioStageBackgroundIcon variant="wave" size="large" />
        <RegioStageBackgroundIcon variant="rocket" size="large" />
        <RegioStageBackgroundIcon variant="present" size="small" />
        <RegioStageBackgroundIcon variant="smiley-happy" size="large" />
        <RegioStageBackgroundIcon variant="sun" size="small" />
        <RegioStageBackgroundIcon variant="heart" size="large" />
      </div>
      <p
        className={clsx(styles.headline, {
          [styles.headlineLong]: isLongHeadline,
        })}
      >
        {stageHeadline}
      </p>
      <h1 className={styles.description}>{description}</h1>
      <div className={styles.stageboxWrapper}>
        <RegioStageBox
          title={stageBoxTitle}
          productFormType="power-gas-combined"
          configuratorBaseUrl={configuratorBaseUrl}
        />
      </div>
    </div>
  );
};

export default RegioStage;
